import React, {createContext} from 'react';
import {useIntl} from "react-intl";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import '../styles/confirm-dialog.css'

export interface DialogContextType {
    showConfirmDialog: (data: ConfirmDialogProps) => Promise<boolean | undefined>;
}

export const DialogContext = createContext<DialogContextType>({} as DialogContextType);

export interface ConfirmDialogProps {
    body : any;
    header?: any
    icon?: string;
    hideIcon?: boolean;
    acceptLabel? : string;
    rejectLabel? : string;
    position? : 'center' | 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | undefined;
}

export const DialogContextProvider = (props: any) => {
    const {formatMessage : f} = useIntl();

   const showConfirmDialog = (data: ConfirmDialogProps) => {
       return new Promise<boolean | undefined>((resolve) => {
            confirmDialog({
                className: 'confirm-dialog',
                message: data.body,
                header:  data.header || f({id :"attention"}),
                icon: data.hideIcon ? undefined : data.icon || 'pi pi-exclamation-triangle',
                acceptLabel: data.acceptLabel || f({id: 'confirm'}),
                rejectLabel: data.rejectLabel || f({id: 'cancel'}),
                position: data.position || "center",
                accept: () => resolve(true),
                reject: () => resolve(false),
                onHide: () => resolve(undefined),
            });
        })
    }

    return <>
        <DialogContext.Provider value={{showConfirmDialog}}>
            {props.children}
            <ConfirmDialog />
        </DialogContext.Provider>
    </>
};
